import React, { useEffect,useState } from 'react';
import { withRouter } from "react-router";
import './CreateNewAccount.css';
import InputField from './components/InputField';
import RailHeader from "./components/RailHeader/RailHeader";
import AccountSection from './components/AccountSection';
import PersonalInfoSection from './components/PersonalInfoSection';
import AddressSection from './components/AddressSection';
import VerificationSuccessFul from './components/VerificationSuccessful';
import ErrorPageModals from '../../components/ErrorPageModals';
import {useCreateNewAccountContainer} from "./CreateNewAccountContainer";
import { scrollErrorText, caseSensitiveCaptcha,couldNotLoadCaptcha,residentialAddressText } from './Constants'

const reloadImage = require('../../images/reload_captcha.webp')
const CreateNewAccount = (props) => {
  const [show,setShow] =useState(false);
  const [timerId,setTimerId] =useState(0);

  const {
    state: {
    newAccount,
    rotate,
    showError,
    reviewData
    },
    action: {
      buttonClicked,
      _toggleChoice,
      closeModal,
      _changeEmail,
      _changeMobile,
      _changeUserData,
      _changeUserName,
      _getDetailsFromOfficePinCode,
      _getDetailsFromPinCode,
      _onReload
    }
  } = useCreateNewAccountContainer(props);

  useEffect(() => {
    toast()
    return () => clearTimeout(timerId)
  },[showError])

  const toast = () => {
    if (showError) {
      setShow(true);
      let timer = setTimeout(() => {
        setShow(false);
      }, 3000)
      setTimerId(timer);
    }
  }

  const toastOnButtonClick = () => {
    const { pinCodeErrorMessage,
      userNameErrorMessage, emailErrorMessage, mobileErrorMessage, officePinCodeErrorMessage, createAccountError, enterCaptcha } = newAccount;
    const errorVal = pinCodeErrorMessage ||
      userNameErrorMessage || emailErrorMessage || mobileErrorMessage || officePinCodeErrorMessage || createAccountError || !enterCaptcha;
      if(errorVal)
      toast();
  }

  const Captcha = ({ captchaLoading, captchaQuestion }) => {
    if (captchaLoading)
      return (<span className='btnLoader' >ff</span>)
    else
      return (<>{captchaQuestion ? <img src={`data:image/jpeg;base64,${captchaQuestion}`} alt="none" height={50} width={200} /> : <div>
        <p className='coudNotLoadCaptcha'>
        {couldNotLoadCaptcha}
        </p>
      </div>}
        <img className="reloadImage" onClick={_onReload} src={reloadImage} alt="none" height={30} width={30} />
      </>)
  }
  const onButtonClick = () => {
    buttonClicked();
    toastOnButtonClick()
  }

    const { securityQuestionList, occupationList, occupation, dateOfBirth,
      pinCode, userName, email, mobileNumber, password, securityAnswer, firstName, lastName, securityQuestion,
      residentialAddress, pinCodeErrorMessage, city, postOffice, regionalState, country,
      cityList, postOfficeList, stateList, gender, maritalStatus, language, officeCheckBoxEnabled,
      userNameErrorMessage, emailErrorMessage, mobileErrorMessage,
      residentialMobileNumber, regFlag, officeAddress, officeMobileNumber,
      officePinCode, officeCityList, officeCity, officePostOfficeList, officePostOffice, officeStateList,
      officeRegionalState, officeCountry, officePinCodeErrorMessage, createAccountError,createAccountErrorMessage,enterCaptcha,captchaQuestion,captchaLoading,irctcDowntimeError } = newAccount;
      const errorId = newAccount?.errorId; 
    if (!securityQuestionList || !occupationList) {
      return null;
    }
  if (irctcDowntimeError) {
    return (<ErrorPageModals irctcDowntimeError={irctcDowntimeError} currentModal='irctcDowntimeError' closeModal={closeModal} errorId={errorId} />)
  }
  return createAccountError ? <ErrorPageModals currentModal={createAccountErrorMessage === 'Invalid Captcha.' ? 'invalidCaptcha': 'genericError'} closeModal={closeModal} errorId={errorId}/>
      : regFlag
        ? <VerificationSuccessFul reviewData={reviewData}/>
        : (
          <React.Fragment>
            {show && <div className='toast'>
              {scrollErrorText}
            </div>}
            <RailHeader buttonClicked={() => onButtonClick()} rotate={rotate} />
            <div className="createAccountForm railAccount_content">
              <AccountSection
                showError={showError}
                title={'Account Setup'}
                securityQuestionList={securityQuestionList}
                userName={userName}
                email={email}
                mobileNumber={mobileNumber}
                password={password}
                securityQuestion={securityQuestion}
                securityAnswer={securityAnswer}
                changeUserData={_changeUserData}
                changeUserName={_changeUserName}
                userNameErrorMessage={userNameErrorMessage}
                changeEmail={_changeEmail}
                emailErrorMessage={emailErrorMessage}
                changeMobile={_changeMobile}
                mobileErrorMessage={mobileErrorMessage}
              />
              <PersonalInfoSection
                showError={showError}
                title={'Personal Info'}
                occupation={occupation}
                occupationList={occupationList}
                firstName={firstName}
                lastName={lastName}
                dateOfBirth={dateOfBirth}
                gender={gender}
                maritalStatus={maritalStatus}
                language={language}
                changeUserData={_changeUserData}
              />
              <AddressSection
                showError={showError}
                title={'Address Info'}
                residentialAddress={residentialAddress}
                mobileNumber={residentialMobileNumber}
                pinCode={pinCode}
                cityList={cityList}
                city={city}
                postOfficeList={postOfficeList}
                postOffice={postOffice}
                stateList={stateList}
                regionalState={regionalState}
                country={country}
                pinCodeErrorMessage={pinCodeErrorMessage}
                changeUserData={_changeUserData}
                getDetailsFromPinCode={_getDetailsFromPinCode}
              />
              <div className="appendBottom40">
                <p className="latoBlack font22 appendBottom20 blacktext">
                  Captcha
                </p>
                <div className="formDataContainer">
                  <div>
                    <div className="captchaImageContainer">
                      <Captcha captchaLoading={captchaLoading} captchaQuestion={captchaQuestion} />
                    </div>
                    <InputField
                      value={enterCaptcha}
                      label="Enter Captcha"
                      maxLength={10}
                      error={showError && !enterCaptcha}
                      type={'text'}
                      className="residentialField"
                      errorMsg={'Invalid CAPTCHA! Please try again'}
                      changeValue={(value) => _changeUserData('enterCaptcha', value)}
                    />
                  </div>
                  <div className="latoRegular font14 appendBottom20 captchaText">
                  {caseSensitiveCaptcha}
                  </div>
                 </div>
              </div>
              <div className="makeFlex checkboxWrapper">
                <span
                  className={`checkbox  ${!officeCheckBoxEnabled ? 'active' : ''}`}
                  onClick={_toggleChoice}
                />
                <span className="font14 darkGreyText checkboxContent">
                {residentialAddressText}
                </span>
              </div>
              {
                officeCheckBoxEnabled &&
            <AddressSection
              showError={showError}
              title={'Office Address Info'}
              residentialAddress={officeAddress}
              mobileNumber={officeMobileNumber}
              pinCode={officePinCode}
              cityList={officeCityList}
              city={officeCity}
              postOfficeList={officePostOfficeList}
              postOffice={officePostOffice}
              stateList={officeStateList}
              regionalState={officeRegionalState}
              country={officeCountry}
              pinCodeErrorMessage={officePinCodeErrorMessage}
              changeUserData={_changeUserData}
              getDetailsFromPinCode={_getDetailsFromOfficePinCode}
            />
              }
            </div>
          </React.Fragment>
        );
  }

export default withRouter(CreateNewAccount);
